module.exports = __webpack_public_path__ + "static/media/FLNExcel.e84c7d4c.png";